
import {defineComponent} from 'vue';
import MyServices from "@/components/SectionServices/MyServices.vue";

export default defineComponent({
  name: 'SectionServices',
  components: {MyServices}
});
